var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99995 2.6H11.7922L13.4 4.36857V9.5C13.4 10.2732 12.7731 10.9 12 10.9H7.99995C7.22675 10.9 6.59995 10.2732 6.59995 9.5V4C6.59995 3.2268 7.22675 2.6 7.99995 2.6ZM7.99995 1H12.0576C12.3393 1 12.608 1.11885 12.7975 1.32733L14.7399 3.46393C14.9072 3.64801 15 3.88784 15 4.13661V9.5C15 11.1569 13.6568 12.5 12 12.5H11.293C11.1904 13.953 9.97914 15.1 8.5 15.1H3.8C2.2536 15.1 1 13.8464 1 12.3V6C1 4.4536 2.2536 3.2 3.8 3.2H5.1078C5.4579 1.93153 6.62014 1 7.99995 1ZM4.99995 4.8H3.8C3.13726 4.8 2.6 5.33726 2.6 6V12.3C2.6 12.9627 3.13726 13.5 3.8 13.5H8.5C9.09459 13.5 9.58818 13.0675 9.6834 12.5H7.99995C6.3431 12.5 4.99995 11.1569 4.99995 9.5V4.8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.2974590f0a718db8bed5a0bda8fdac38.svg";
export { ForwardRef as ReactComponent };